import { render, staticRenderFns } from "./tooling-setting-card.component.vue?vue&type=template&id=9e175b68&scoped=true"
import script from "./tooling-setting-card.component.vue?vue&type=script&lang=ts"
export * from "./tooling-setting-card.component.vue?vue&type=script&lang=ts"
import style0 from "./tooling-setting-card.component.vue?vue&type=style&index=0&id=9e175b68&prod&scoped=true&lang=scss"
import style1 from "./tooling-setting-card.component.vue?vue&type=style&index=1&id=9e175b68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e175b68",
  null
  
)

export default component.exports